__turbopack_context__.v({
  "counter": "IcKmTW_counter",
  "currentPrice": "IcKmTW_currentPrice",
  "insideWrapper": "IcKmTW_insideWrapper",
  "oldPrice": "IcKmTW_oldPrice",
  "priceWrapper": "IcKmTW_priceWrapper",
  "producerName": "IcKmTW_producerName",
  "productDetails": "IcKmTW_productDetails",
  "productName": "IcKmTW_productName",
  "productUnitDetails": "IcKmTW_productUnitDetails",
  "wrapper": "IcKmTW_wrapper",
});
